export default __webpack_public_path__ + "static/media/success_thumb.f967dceb.png";